module.exports = __webpack_public_path__ + "static/media/public_inactive_1.152c3c25.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/bin/public_inactive_1.png
// module id = 3479
// module chunks = 0